import React, { useEffect } from 'react';

const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
        }, []);

    return (
        <div className="privacy-policy">
            <div className="section">
            <h2>Privacy Policy</h2>
                <p>
                    At Rhodiumroot we are committed to protecting your privacy and personal
                    information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information
                    when you use our website and services.
                </p>
                <h3>Information We May Collect</h3>
                <p>We collect information that you provide directly to us, including:</p>
                <ul>
                    <li>Name and contact information</li>
                    <li>Account credentials</li>
                    <li>Health and Nutrition information</li>
                    <li>Communication preferences</li>
                </ul>
                <p>We may automatically collect certain information when you use our service.</p>
                <ul>
                    <li>Device information</li>
                    <li>Log data</li>
                    <li>Usage information</li>
                    <li>Cookies and similar technologies</li>
                </ul>
                <h3>How We Use Your Information</h3>
                <p>We use the collected information for several function to improve the service provided.</p>
                <ul>
                    <li>Providing and maintaining our services</li>
                    <li>Processing your transactions</li>
                    <li>Communicating with you</li>
                    <li>Improving our services</li>
                    <li>Complying with legal obligations</li>
                </ul>
                <h3>Information Sharing and Disclosure</h3>
                <p>We may share your information with some third parities based on the application interaction or legal request.</p>
                <ul>
                    <li>Service providers and business partners</li>
                    <li>Legal authorities when required by law</li>
                    <li>Other parties with your consent</li>
                </ul>
                <h3>Data Security</h3>
                <p>
                    We implement appropriate technical and organizational measures to protect your personal information.
                    However, no method of transmission over the Internet is 100% secure.
                </p>
                <h3>Your Rights</h3>
                <p>You have the basic rights associated with your information.</p>
                <ul>
                    <li>Access to your personal information</li>
                    <li>Correct inaccurate information</li>
                    <li>Request deletion of your information</li>
                </ul>
                <h3>Cookies</h3>
                <p>
                    We may use cookies and similar tracking technologies to track activity on our service and hold certain
                    information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being
                    sent.
                </p>
                <h3>Children's Privacy</h3>
                <p>
                    Our service is not directed to children under 13. We do not knowingly collect personal information
                    from children under 13. If you become aware that a child has provided us with personal information,
                    please contact us.
                </p>
                <h3>Changes to This Privacy Policy</h3>
                <p>
                    We may update our Privacy Policy from time to time. Any changes to update the Privacy Policy will be posted on this page.
                </p>
                <h3>Contact Us</h3>
                <p>
                    If you have any questions about this Privacy Policy, please contact us at: Rhodiumroot.com
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
